import { RouteLocationNormalized } from "vue-router";
import { roleResolver } from "./role.resolver";
import { zonesResolver } from "./zones.resolver";

export const roleWithZonesResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await Promise.all([roleResolver(to, from), zonesResolver(to, from)]);
    } catch (error) {
        console.error('ROLE_WITH_ZONES_RESOLVER_ERROR');
        return { name: 'Roles' };
    }
}